import { Button } from '#/components/Button/Button';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { useI18n } from '#/i18n/hooks/useI18n';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';

import {
  AcceptCookies_Box_1,
  AcceptCookiesContainer,
} from './AcceptCookies.styled';

type Props = {
  onAcceptCookies: () => void;
  submitting: boolean;
};

export function AcceptCookies({ onAcceptCookies, submitting }: Props) {
  const { i18n } = useI18n();

  return (
    <AcceptCookiesContainer data-qa-id="accept-cookies-alert">
      <div>
        {
          /* TRANSLATORS: accept cookie message in page footer for EU */
          i18n(
            'This site uses cookies. By continuing to use our site, you agree to our use of cookies as described in our {{link}}Cookie Policy{{/link}}.',
            {
              link: (
                <StyledNativeLinkWithRef
                  href="https://info.idealist.org/cookie-policy/"
                  onClick={(event) =>
                    trackAnchorClicked(event, 'Resource Page')
                  }
                />
              ),
            },
          )
        }
      </div>

      <AcceptCookies_Box_1>
        <Button
          type="button"
          variant="primary"
          size="small"
          onClick={onAcceptCookies}
          disabled={submitting}
          qaId="accept-cookies-button"
        >
          {
            /* TRANSLATORS: accept cookies button text */
            i18n('OK')
          }
        </Button>
      </AcceptCookies_Box_1>
    </AcceptCookiesContainer>
  );
}
